import notify from "devextreme/ui/notify";
import { formatDate } from "devextreme/localization";
import router from "@/router";

export default {
  info(msg, timeout) {
    notify(msg, "info", timeout ? timeout : 5000);
  },
  warning(msg, timeout) {
    notify(msg, "warning", timeout ? timeout : 10000);
  },
  success(msg, timeout) {
    notify(msg, "success", timeout ? timeout : 5000);
  },
  error(msg, timeout) {
    notify(
      {
        closeOnSwipe: false,
        message: msg
      },
      "error",
      timeout ? timeout : msg.length <= 100 ? 8000 : (msg.length / 100) * 8000
    );
    console.error(msg); //eslint-disable-line
  },
  handleError(err, proceso) {
    let actualNavegador = formatDate(new Date(), "dd/MM/yyyy HH:mm:ss");
    let storage = localStorage.getItem("carto-errores");
    let errores = storage ? JSON.parse(storage) : [];
    if (errores && errores.length > 10) {
      while (errores.length > 10) {
        errores.shift();
      }
    }
    let route = router.currentRoute;
    let app = process.env.APP_NAME;
    let urlError = err.config ? err.config.url : null;
    let error = {
      app: app,
      path: route.fullPath,
      route: route.name,
      params: route.params,
      date: actualNavegador,
      msg: "",
      proceso: proceso,
      url: urlError,
      method: err.config ? err.config.method : null,
      data: err.config ? err.config.data : null
    };

    if (!err.response) {
      let msg = err.message;
      if (urlError) {
        msg = `No se puede establecer conexión con el servidor: ${urlError} [${actualNavegador}]`;
      }
      error.msg = msg;
      notify(
        {
          closeOnSwipe: false,
          message: `${msg}`
        },
        "error",
        5000
      );
    } else {
      let msg = `${actualNavegador}: ${
        err.response.data
          ? err.response.data.message
            ? err.response.data.message
            : err.response.data
          : err.response
      }`;

      error.msg = msg;
      error.trace = err.response.data.trace;
      if (error.trace) {
        console.error(error.trace); //eslint-disable-line
      }
      notify(
        {
          closeOnSwipe: false,
          message: msg
        },
        "error",
        msg.length <= 100 ? 5000 : (msg.length / 100) * 5000
      );
    }
    errores.push(error);
    localStorage.setItem("carto-errores", JSON.stringify(errores));
  }
};
